<template>
    <div data-cy="container_campaign_search_bar">
        <div class="relative">
            <input type="text"
                data-cy="input_campaign_search"
                class="input-search w-full bg-a-blue-f2f5ff text-a-blue-2140a6 placeholder-a-gray-a4a4a4 text-12 rounded-lg pl-8 pr-4 py-3"
                :class="{'blue': isBlueIcon}"
                :style="{ '--icon-url': 'url(' + (isBlueIcon ? iconSearchBlueUrl() : iconSearchUrl()) + ')' }"
                v-model="content"
                :placeholder="txtPlaceholder"
                @keyup.enter="onEnter()"
                @input="onChange()">
        </div>
    </div>
</template>
<script>
import RegxHelper from "@/helper/RegxHelper.js";
import ConfigManager from "@/config/ConfigManager.js";

export default {
    name: "InputSearch",
    props: {
        //v-model
        inputValue: String,
        //props
        minLength: Number,
        maxLength: Number,
        isTextOnly: Boolean,
        isBlueIcon: { type: Boolean, default: false },
        //text
        txtPlaceholder: String,
    },
    data: function() {
        return {
            content: this.inputValue,
        };
    },
    methods: {
        onChange: function() {
            var result = this.content;

            if (this.isTextOnly) {
                result = RegxHelper.removeEmoji(result);
                //result = RegxHelper.removeNumber(result);
                result = RegxHelper.removeSymbol(result);
            }

            this.content = result;

            if(!this.content){
                this.$emit('onChange', this.content);
            }

            this.$emit('update:inputValue', result);
        },
        onEnter: function(){
            this.$emit('onEnter');
        },
        iconSearchUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/ic-search.svg`;
        },
        iconSearchBlueUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/ic-search-blue.svg`;
        },
        clearInput: function(){
            this.content = null;
        }
    },
}
</script>
<style lang="scss" scoped>
.input-search{
    background-image: var(--icon-url);
    background-repeat: no-repeat;
    background-position: top 14px left 15px;
}
</style>
